export class RouteParamsValidationException extends Error {
	route: string;

	constructor(message: string, route: string) {
		super(message);
		this.route = route;
	}
}
